import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import { DEFAULT_OPACITY } from "../shared/constants";

export default class Appearance extends AbstractProvidedClass {
    parent;

    constructor(provider, data = {}) {
        super(provider);
        this.fillColor = data.fillColor ?? null;
        this.strokeColor = data.strokeColor ?? null;
        this.strokeWidth = data.strokeWidth ?? null;
    }

    apply(g, opacity = 1) {
        const fillColor = this.getFillColor(opacity);
        fillColor
            ? g.fill(fillColor)
            : g.noFill();

        const strokeColor = this.getStrokeColor(opacity);
        if (strokeColor) {
            g.stroke(strokeColor);
            g.strokeWeight(this.scaledStrokeWidth);
        } else {
            g.noStroke();
        }
    }

    drawOuterHighlight(g, highlight, buildPath, lineJoin = 'miter') {
        const ctx = g.drawingContext;
        ctx.save();

        ctx.beginPath();
        buildPath(ctx);
        ctx.rect(-1e7, -1e7, 2e7, 2e7);
        ctx.clip('evenodd');

        ctx.beginPath();
        buildPath(ctx);

        const colorMap = {
            flash: 'rgb(200, 0, 150)',
            hovered: 'rgb(255, 255, 0)',
            selected: 'rgb(255, 130, 0)',
        };
        ctx.strokeStyle = colorMap[highlight];
        ctx.lineWidth = this.scaledStrokeWidth + 5;
        ctx.lineJoin = lineJoin;
        ctx.stroke();

        ctx.restore();
    }

    get scaledStrokeWidth() {
        return this.strokeWidth ? Math.max(0.5, this.strokeWidth * this.view.scale) : 1;
    }

    getFillColor(opacity) {
        if (!this.fillColor) return null;
        if (this.parent?.layer) {
            opacity *= this.parent.layer.opacity
        }
        this.fillColor.setAlpha(opacity * DEFAULT_OPACITY);
        return this.fillColor;
    }

    getStrokeColor(opacity) {
        if (!this.strokeColor) return null;
        if (this.parent?.layer) {
            opacity *= this.parent.layer.opacity
        }
        this.strokeColor.setAlpha(opacity * 255);
        return this.strokeColor;
    }

    setParent(parent) {
        this.parent = parent;
        return this;
    }

    applyToSvg(svg, scale = 1) {
        svg.fill(
            this.fillColor
                ? { color: this.fillColor.toString(), opacity: DEFAULT_OPACITY / 255 }
                : 'none'
        );
        if (this.strokeColor) {
            svg.stroke({
                color: this.strokeColor.toString(),
                width: Math.max(0.5, this.strokeWidth ? this.strokeWidth * scale : 1),
            });
        } else {
            svg.stroke('none');
        }
    }

    clone() {
        this.fillColor ? this.fillColor.setAlpha(255) : null;
        return new Appearance(
            this.provider,
            {
                fillColor: this.fillColor ? this.p.color(this.fillColor.toString()) : null,
                strokeColor: this.strokeColor ? this.p.color(this.strokeColor.toString()) : null,
                strokeWidth: this.strokeWidth,
            }
        );
    }

    export() {
        this.fillColor ? this.fillColor.setAlpha(255) : null;
        this.strokeColor ? this.strokeColor.setAlpha(255) : null;
        return {
            fillColor: this.fillColor ? this.fillColor.toString() : null,
            strokeColor: this.strokeColor ? this.strokeColor.toString() : null,
            strokeWidth: this.strokeWidth ? this.strokeWidth : null,
        }
    }
}
